module.exports = __webpack_public_path__ + "static/img/m_name.9f7b2d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/yzzzbq/m_name.png
// module id = lqyz
// module chunks = 7